import React from 'react';
import '../styles/TermsAndConditions.css';

const TermsAndConditions = () => {
  return (
    <div className="terms-container">
      <h2 className="terms-title">📜 الشروط والأحكام الخاصة بعضوية شركة جيناي الفلسطينية</h2>

      <section className="terms-section">
        <h3>مقدمة</h3>
        <p>مرحبًا بك في شركة جيناي الفلسطينية.</p>
        <p>يرجى قراءة هذه الشروط والأحكام بعناية قبل إتمام تسجيل العضوية.</p>
        <p>بموافقتك على هذه الشروط، فإنك تقر وتوافق على الالتزام بكافة البنود الواردة أدناه، ويُعتبر ذلك موافقة قانونية ملزمة وفق القوانين المعمول بها في فلسطين.</p>
      </section>

      <section className="terms-section">
        <h3>أولًا: شروط التسجيل</h3>
        <ol>
          <li>تسجيل العضوية مجاني تماما في جيناي ولا نتقاضى أي رسوم مقابل العضوية</li>
          <li>التسجيل في شركة جيناي الفلسطينية لكل الأشخاص بدون شرط او قيد.</li>
          <li>لا يستطيع أي شخص تسجيل عضوية من دون رقم معرف او راعي له (عضو اخر دعاه للشركة)</li>
          <li>الأشخاص الذين عمرهم اقل من 18 سنة يتم تسجيلهم من خلال ولي امر.</li>
          <li>يتحمل العضو كامل المسؤولية القانونية عن صحة المعلومات التي يقدمها.</li>
          <li>بمجرد إدخال بيناتك يتم إصدار رقم عضوية خاص بك هو (رقم عضويتك / أو كود الخصم الخاص بك)</li>
          <li>لا يُسمح بتسجيل الشخص أكثر من مرة، ويُمنع تكرار الحسابات. وفي حال حصل ذلك تلغى العضوية الأحدث وتنقل كل النقاط والفريق من العضوية الأحدث الى العضوية الأولى.</li>
          <li>من خلال رقم عضويتك وكلمة المرور الخاصة بك بإمكانك دخول حسابك على موقع الشركة وتصفح المنتجات و الخدمات وشرائها او طلبها وأيضا رؤية أداء فريقك وأرباحك الشهرية.</li>
          <li>رقم العضوية دائم وصالح مدى الحياة ويورث لعائلة العضو حسب الشرع او حسب الوصية.</li>
        </ol>
      </section>

      <section className="terms-section">
        <h3>ثانيًا: طبيعة العضوية</h3>
        <ol>
          <li>العضوية في جيناي لا تُعد توظيفًا ولا عقد عمل.</li>
          <li>العضوية تتيح للعضو:
            <ul>
              <li>التسوق والتسويق</li>
              <li>جمع النقاط</li>
              <li>الاستفادة من نظام العمولات</li>
              <li>بناء فريق وفق نظام الشركة</li>
            </ul>
          </li>
          <li>لا يوجد حد ادنى من النقاط لقبض الارباح للعضو.. ويحق للعضو قبض ارباح عن فريقه حتى لو لم يسجل اي نقطة في حسابه الشخصي</li>
          <li>لا يوجد اي شرط او اجبار على الاعضاء لشراء اي منتج او خدمة من الشركة</li>
          <li>الأرباح غير ثابتة وتعتمد على نشاط العضو وجهده والتزامه بنظام العمل</li>
          <li>يستفيد العضو من خمسة أجيال تحت اسمه عموديا</li>
          <li>يستفيد العضو من الخطوط الافقية المباشرة تحت اسمه مهما كان عددها</li>
        </ol>
      </section>

      <section className="terms-section">
        <h3>ثالثًا: نظام النقاط والرتب والأرباح</h3>
        <ol>
          <li>يتم احتساب النقاط والرتب والأرباح وفق:
            <ul>
              <li>نظام الشركة المعتمد (الخطة المالية) للاطلاع عليها <button onClick={() => window.open('/financial-plan', '_blank')} className="terms-link" style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}>اضغط هنا</button></li>
            </ul>
          </li>
          <li>تحتفظ الشركة بحق:
            <ul>
              <li>تعديل نظام النقاط أو الرتب</li>
              <li>تطوير السيستم</li>
              <li>تغيير آليات الاحتساب</li>
            </ul>
            بما يخدم مصلحة الشركة والأعضاء، مع إشعار الأعضاء بذلك.
          </li>
          <li>تُصرف الأرباح بنهاية كل دورة ربحية حسب سياسة الشركة.</li>
          <li>تسلم الأرباح للعضو فوق ال18 سنة له شخصيا او لاي شخص تم تفويضه رسميا من خلال تقديم طلب للإدارة والموافقة عليه.</li>
          <li>الأعضاء تحت ال18 سنة يستلم ولي امره الأرباح نييابة عنه</li>
        </ol>
      </section>

      <section className="terms-section">
        <h3>رابعًا: السلوك والالتزام</h3>
        <ol>
          <li>يلتزم العضو بالالتزام بأخلاقيات العمل، واحترام:
            <ul>
              <li>القادة</li>
              <li>الأعضاء</li>
              <li>إدارة الشركة</li>
            </ul>
          </li>
          <li>يُمنع:
            <ul>
              <li>التلاعب بالنظام</li>
              <li>تقديم معلومات مضللة</li>
              <li>الإساءة للشركة أو أعضائها</li>
            </ul>
          </li>
          <li>في حال المخالفة، يحق للشركة:
            <ul>
              <li>إيقاف العضوية مؤقتًا</li>
              <li>أو إلغاؤها نهائيًا</li>
              <li>أو حجب الأرباح المستحقة</li>
            </ul>
          </li>
        </ol>
      </section>

      <section className="terms-section">
        <h3>خامسًا: تعديل البيانات</h3>
        <ol>
          <li>يحق للعضو تعديل كلمة المرور فقط من خلال حسابه.</li>
          <li>أي تعديل آخر على البيانات يتطلب موافقة الإدارة.</li>
        </ol>
      </section>

      <section className="terms-section">
        <h3>سادسًا: إنهاء العضوية</h3>
        <ol>
          <li>يحق للعضو طلب إنهاء عضويته وفق سياسة الشركة. ولا يطلب منه أي رسوم او غرامة</li>
          <li>تحتفظ الشركة بحق إنهاء أو تعليق أي عضوية في حال:
            <ul>
              <li>مخالفة الشروط</li>
              <li>الإضرار بسمعة الشركة</li>
              <li>التلاعب بالنظام</li>
              <li>انتهاء فرصته بعد 3 إنذارات رسمية من الشركة له.</li>
            </ul>
          </li>
        </ol>
      </section>

      <section className="terms-section">
        <h3>سابعًا: المسؤولية القانونية</h3>
        <ol>
          <li>شركة جيناي الفلسطينية غير مسؤولة عن:
            <ul>
              <li>أي خسائر ناتجة عن سوء استخدام النظام</li>
              <li>أو قرارات فردية يتخذها العضو</li>
            </ul>
          </li>
          <li>يتحمل العضو المسؤولية الكاملة عن نشاطه داخل السيستم.</li>
        </ol>
      </section>

      <section className="terms-section">
        <h3>ثامنًا: الخصوصية وحماية البيانات</h3>
        <ol>
          <li>تلتزم الشركة بحماية بيانات الأعضاء.</li>
          <li>لا يتم مشاركة البيانات مع أي طرف ثالث إلا وفق القانون أو بموافقة العضو.</li>
        </ol>
      </section>

      <section className="terms-section">
        <h3>تاسعًا: القانون والاختصاص القضائي</h3>
        <p>تخضع هذه الشروط لأحكام القانون الفلسطيني، وتكون محاكم دولة فلسطين المختصة هي المرجع الوحيد للنظر في أي نزاع.</p>
      </section>

      <section className="terms-section terms-acknowledgment">
        <h3>عاشرًا: الإقرار والموافقة</h3>
        <p>بالضغط على زر <strong>(أوافق على الشروط والأحكام)</strong>، أقرّ أنا بما يلي:</p>
        <ul>
          <li>قرأت جميع الشروط والأحكام</li>
          <li>فهمتها بالكامل</li>
          <li>أوافق عليها</li>
          <li>وألتزم بتنفيذها</li>
        </ul>
      </section>
    </div>
  );
};

export default TermsAndConditions;
